import createAdminPaymentGateway from './createPaymentGateway';
import createAdminPaymentMethod from './createPaymentMethod';
import createAdminPaymentMethodGateway from './createPaymentMethodGateway';

import deleteAdminPaymentGateway from './deletePaymentGateway';
import deleteAdminPaymentMethod from './deletePaymentMethod';
import deleteAdminPaymentMethodGateway from './deletePaymentMethodGateway';

import fetchAdminPaymentGateways from './fetchPaymentGateways';
import fetchAdminPaymentMethodGateway from './fetchPaymentMethodGateway';
import fetchAdminPaymentMethods from './fetchPaymentMethods';

import updateAdminPaymentGateway from './updatePaymentGateway';
import updateAdminPaymentMethod from './updatePaymentMethod';
import updateAdminPaymentMethodGateway from './updatePaymentMethodGateway';

import createAdminChargeStatus from './createChargeStatus';
import updateAdminChargeStatus from './updateChargeStatus';
import deleteAdminChargeStatus from './deleteChargeStatus';
import fetchAdminChargeStatus from './fetchChargeStatus';

import createAdminChargeStatusGateway from './createChargeStatusGateway';
import updateAdminChargeStatusGateway from './updateChargeStatusGateway';
import deleteAdminChargeStatusGateway from './deleteChargeStatusGateway';
import fetchAdminChargeStatusGateway from './fetchChargeStatusGateway';

export default {
  createAdminPaymentGateway,
  createAdminPaymentMethod,
  createAdminPaymentMethodGateway,
  deleteAdminPaymentGateway,
  deleteAdminPaymentMethod,
  deleteAdminPaymentMethodGateway,
  fetchAdminPaymentGateways,
  fetchAdminPaymentMethodGateway,
  fetchAdminPaymentMethods,
  updateAdminPaymentGateway,
  updateAdminPaymentMethod,
  updateAdminPaymentMethodGateway,
  createAdminChargeStatus,
  updateAdminChargeStatus,
  deleteAdminChargeStatus,
  fetchAdminChargeStatus,
  createAdminChargeStatusGateway,
  updateAdminChargeStatusGateway,
  deleteAdminChargeStatusGateway,
  fetchAdminChargeStatusGateway,
};
